export const VCONNECT_NAME = 'VConnect';
export const VCONNECT_TAGLINE = 'Operations Management System';
export const VCONNECT_ORGANIZATION = 'Verdantrise Humanitarian Initiative';
export const VCONNECT_BRAND_IMAGE = '/branding/vconnect-operations-management.png';
